import { FunctionComponent } from "react";

import {
  button,
  icon,
} from "@ui/components/article/ShareButtons/ShareButtons.css";
import FacebookIcon from "@ui/components/icon/social/FacebookIcon";
import { ArticleLayout } from "@ui/components/ledes/ledes.types";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
  title: string;
  layout: ArticleLayout | "stream" | "video";
}

const ShareButtonsFacebook: FunctionComponent<Props> = ({
  url,
  title,
  layout,
}) => {
  const analytics = useAnalytics();
  const handleClick = () => {
    analytics?.emit({
      event: "social_share",
      social_share: { platform: "facebook" },
    });

    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&text=${title}`;

    return window.open(
      facebookUrl,
      "share_facebook",
      "width=658, height=354, scrollbars=no",
    );
  };

  return (
    <button
      aria-label="Share on Facebook"
      onClick={handleClick}
      className={button[layout]}
    >
      <FacebookIcon className={icon[layout]} />
    </button>
  );
};

export default ShareButtonsFacebook;
